import { render, staticRenderFns } from "./be-called-back.component.vue?vue&type=template&id=1219ea86&"
import script from "./be-called-back.component.vue?vue&type=script&lang=ts&"
export * from "./be-called-back.component.vue?vue&type=script&lang=ts&"
import style0 from "./be-called-back.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "be-called-back.component.vue"
export default component.exports